'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataTableHeader = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DataTable = require('./DataTable.scss');

var _DataTable2 = _interopRequireDefault(_DataTable);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _InfiniteScroll = require('./InfiniteScroll');

var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);

var _WixComponent2 = require('../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _ArrowVertical = require('../Icons/dist/components/ArrowVertical');

var _ArrowVertical2 = _interopRequireDefault(_ArrowVertical);

var _wixAnimations = require('wix-animations');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataTableHeader = exports.DataTableHeader = function DataTableHeader(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'table',
      { style: { width: props.width }, className: _DataTable2.default.table },
      _react2.default.createElement(TableHeader, props)
    )
  );
};

DataTableHeader.propTypes = {
  width: _propTypes2.default.number
};

var DataTable = function (_WixComponent) {
  _inherits(DataTable, _WixComponent);

  function DataTable(props) {
    _classCallCheck(this, DataTable);

    var _this = _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this, props));

    _this.wrapWithInfiniteScroll = function (table) {
      return _react2.default.createElement(
        _InfiniteScroll2.default,
        {
          pageStart: 0,
          loadMore: _this.loadMore,
          hasMore: _this.state.currentPage < _this.state.lastPage || _this.props.hasMore,
          loader: _this.props.loader,
          useWindow: _this.props.useWindow,
          scrollElement: _this.props.scrollElement
        },
        table
      );
    };

    _this.renderTable = function (rowsToRender) {
      var style = { width: _this.props.width };
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'table',
          { id: _this.props.id, style: style, className: _DataTable2.default.table },
          !_this.props.hideHeader && _react2.default.createElement(TableHeader, _this.props),
          _this.renderBody(rowsToRender)
        )
      );
    };

    _this.renderBody = function (rows) {
      return _react2.default.createElement(
        'tbody',
        null,
        rows.map(_this.renderRow)
      );
    };

    _this.onRowClick = function (rowData, rowNum) {
      var _this$props = _this.props,
          onRowClick = _this$props.onRowClick,
          rowDetails = _this$props.rowDetails;

      onRowClick && onRowClick(rowData, rowNum);
      rowDetails && _this.toggleRowDetails(rowNum);
    };

    _this.renderRow = function (rowData, rowNum) {
      var _this$props2 = _this.props,
          onRowClick = _this$props2.onRowClick,
          onMouseEnterRow = _this$props2.onMouseEnterRow,
          onMouseLeaveRow = _this$props2.onMouseLeaveRow,
          rowDataHook = _this$props2.rowDataHook,
          dynamicRowClass = _this$props2.dynamicRowClass,
          rowDetails = _this$props2.rowDetails;

      var rowClasses = [_this.props.rowClass];
      var optionalRowProps = {};

      var handlers = [{ rowEventHandler: _this.onRowClick, eventHandler: 'onClick' }, { rowEventHandler: onMouseEnterRow, eventHandler: 'onMouseEnter' }, { rowEventHandler: onMouseLeaveRow, eventHandler: 'onMouseLeave' }];

      handlers.forEach(function (_ref) {
        var rowEventHandler = _ref.rowEventHandler,
            eventHandler = _ref.eventHandler;

        if (rowEventHandler) {
          optionalRowProps[eventHandler] = function (event) {
            if (event.isDefaultPrevented()) {
              return;
            }
            rowEventHandler(rowData, rowNum);
          };
        }
      });

      if (onRowClick) {
        rowClasses.push(_DataTable2.default.clickableDataRow);
      }

      if (rowDetails) {
        rowClasses.push(_DataTable2.default.animatedDataRow);
      }

      if (rowDataHook) {
        if (typeof rowDataHook === 'string') {
          optionalRowProps['data-hook'] = rowDataHook;
        } else {
          optionalRowProps['data-hook'] = rowDataHook(rowData, rowNum);
        }
      }

      if (dynamicRowClass) {
        rowClasses.push(dynamicRowClass(rowData, rowNum));
      }

      optionalRowProps.className = (0, _classnames2.default)(rowClasses);

      var rowsToRender = [_react2.default.createElement(
        'tr',
        _extends({ 'data-table-row': 'dataTableRow', key: rowNum }, optionalRowProps),
        _this.props.columns.map(function (column, colNum) {
          return _this.renderCell(rowData, column, rowNum, colNum);
        })
      )];

      if (rowDetails) {
        var showDetails = !!_this.state.selectedRows[rowNum];

        rowsToRender.push(_react2.default.createElement(
          'tr',
          { key: rowNum + '_details', className: (0, _classnames2.default)(_DataTable2.default.rowDetails) },
          _react2.default.createElement(
            'td',
            {
              'data-hook': rowNum + '_details', className: (0, _classnames2.default)(_DataTable2.default.details, showDetails ? _DataTable2.default.active : ''),
              colSpan: _this.props.columns.length
            },
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)(_DataTable2.default.rowDetailsInner) },
              _react2.default.createElement(
                _wixAnimations.Animator,
                { show: showDetails, height: true },
                rowDetails(rowData, rowNum)
              )
            )
          )
        ));
      }

      return rowsToRender;
    };

    _this.renderCell = function (rowData, column, rowNum, colNum) {
      var classes = (0, _classnames2.default)(_defineProperty({}, _DataTable2.default.important, column.important));
      var width = rowNum === 0 && _this.props.hideHeader ? column.width : undefined;

      return _react2.default.createElement(
        'td',
        {
          style: column.style,
          width: width,
          className: classes,
          key: colNum
        },
        column.render && column.render(rowData, rowNum)
      );
    };

    _this.calcLastPage = function (_ref2) {
      var data = _ref2.data,
          itemsPerPage = _ref2.itemsPerPage;
      return Math.ceil(data.length / itemsPerPage) - 1;
    };

    _this.loadMore = function () {
      if (_this.state.currentPage < _this.state.lastPage) {
        _this.setState({ currentPage: _this.state.currentPage + 1 });
      } else {
        _this.props.loadMore && _this.props.loadMore();
      }
    };

    _this.toggleRowDetails = function (selectedRow) {
      var selectedRows = _defineProperty({}, selectedRow, !_this.state.selectedRows[selectedRow]);
      if (_this.props.allowMultiDetailsExpansion) {
        selectedRows = Object.assign({}, _this.state.selectedRows, _defineProperty({}, selectedRow, !_this.state.selectedRows[selectedRow]));
      }
      _this.setState({ selectedRows: selectedRows });
    };

    var state = { selectedRows: {} };
    if (props.infiniteScroll) {
      state = _extends({}, state, _this.createInitialScrollingState(props));
    }
    _this.state = state;
    return _this;
  }

  _createClass(DataTable, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isLoadingMore = false;
      if (this.props.infiniteScroll && nextProps.data !== this.props.data) {
        if (nextProps.data instanceof Array && this.props.data instanceof Array) {
          if (this.props.data.every(function (elem, index) {
            return nextProps.data.length > index && nextProps.data[index] === elem;
          })) {
            isLoadingMore = true;
            var lastPage = this.calcLastPage(nextProps);
            var currentPage = this.state.currentPage < lastPage ? this.state.currentPage + 1 : this.state.currentPage;
            this.setState({ lastPage: lastPage, currentPage: currentPage });
          }
        }
        if (!isLoadingMore) {
          this.setState(this.createInitialScrollingState(nextProps));
        }
      }
    }
  }, {
    key: 'createInitialScrollingState',
    value: function createInitialScrollingState(props) {
      return { currentPage: 0, lastPage: this.calcLastPage(props) };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          showHeaderWhenEmpty = _props.showHeaderWhenEmpty,
          infiniteScroll = _props.infiniteScroll,
          itemsPerPage = _props.itemsPerPage;


      if (!data.length && !showHeaderWhenEmpty) {
        return null;
      }

      var rowsToRender = infiniteScroll ? data.slice(0, (this.state.currentPage + 1) * itemsPerPage) : data;

      var table = this.renderTable(rowsToRender);

      if (infiniteScroll) {
        return this.wrapWithInfiniteScroll(table);
      }

      return table;
    }
  }]);

  return DataTable;
}(_WixComponent3.default);

var TableHeader = function (_Component) {
  _inherits(TableHeader, _Component);

  function TableHeader() {
    var _ref3;

    var _temp, _this2, _ret;

    _classCallCheck(this, TableHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref3 = TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).call.apply(_ref3, [this].concat(args))), _this2), _this2.renderSortingArrow = function (sortDescending, colNum) {
      if (sortDescending === undefined) {
        return null;
      }
      var sortDirectionClassName = sortDescending ? _DataTable2.default.sortArrowAsc : _DataTable2.default.sortArrowDesc;
      return _react2.default.createElement(
        'span',
        { 'data-hook': colNum + '_title', className: sortDirectionClassName },
        _react2.default.createElement(_ArrowVertical2.default, null)
      );
    }, _this2.renderHeaderCell = function (column, colNum) {
      var style = {
        width: column.width,
        padding: _this2.props.thPadding,
        height: _this2.props.thHeight,
        fontSize: _this2.props.thFontSize,
        border: _this2.props.thBorder,
        color: _this2.props.thColor,
        opacity: _this2.props.thOpacity,
        letterSpacing: _this2.props.thLetterSpacing,
        cursor: column.sortable === undefined ? 'arrow' : 'pointer'
      };

      var optionalHeaderCellProps = {};
      if (column.sortable) {
        optionalHeaderCellProps.onClick = function () {
          return _this2.props.onSortClick && _this2.props.onSortClick(column, colNum);
        };
      }
      return _react2.default.createElement(
        'th',
        _extends({
          style: style,
          key: colNum
        }, optionalHeaderCellProps),
        column.title,
        _this2.renderSortingArrow(column.sortDescending, colNum)
      );
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(TableHeader, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          null,
          this.props.columns.map(this.renderHeaderCell)
        )
      );
    }
  }]);

  return TableHeader;
}(_react.Component);

TableHeader.propTypes = {
  onSortClick: _propTypes2.default.func,
  thPadding: _propTypes2.default.string,
  thHeight: _propTypes2.default.string,
  thFontSize: _propTypes2.default.string,
  thBorder: _propTypes2.default.string,
  thColor: _propTypes2.default.string,
  thOpacity: _propTypes2.default.string,
  thLetterSpacing: _propTypes2.default.string,
  columns: _propTypes2.default.array
};


function validateData(props, propName) {
  if (props[propName]) {
    if (props[propName].constructor && props[propName].constructor.name && props[propName].constructor.name.toLowerCase().indexOf('array') > -1) {
      return null;
    } else {
      return Error('Data element must be an array type');
    }
  }
  return null;
}

DataTable.defaultProps = {
  data: [],
  columns: [],
  showHeaderWhenEmpty: false,
  infiniteScroll: false,
  itemsPerPage: 20,
  width: '100%',
  loadMore: null,
  hasMore: false,
  loader: _react2.default.createElement(
    'div',
    { className: 'loader' },
    'Loading ...'
  ),
  scrollElement: null,
  useWindow: true,
  thPadding: '5px',
  thHeight: '36px',
  thFontSize: '12px'
};

DataTable.propTypes = {
  id: _propTypes2.default.string,
  data: validateData,
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    title: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]).isRequired,
    render: _propTypes2.default.func.isRequired,
    sortable: _propTypes2.default.bool,
    sortDescending: _propTypes2.default.bool
  })),
  showHeaderWhenEmpty: _propTypes2.default.bool,
  rowDataHook: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  rowClass: _propTypes2.default.string,
  dynamicRowClass: _propTypes2.default.func,
  onRowClick: _propTypes2.default.func,
  onMouseEnterRow: _propTypes2.default.func,
  onMouseLeaveRow: _propTypes2.default.func,
  infiniteScroll: _propTypes2.default.bool,
  itemsPerPage: _propTypes2.default.number,
  width: _propTypes2.default.string,
  loadMore: _propTypes2.default.func,
  hasMore: _propTypes2.default.bool,
  loader: _propTypes2.default.node,
  useWindow: _propTypes2.default.bool,
  scrollElement: _propTypes2.default.object,
  thPadding: _propTypes2.default.string,
  thHeight: _propTypes2.default.string,
  thFontSize: _propTypes2.default.string,
  thBorder: _propTypes2.default.string,
  thColor: _propTypes2.default.string,
  thOpacity: _propTypes2.default.string,
  thLetterSpacing: _propTypes2.default.string,
  rowDetails: _propTypes2.default.func,
  allowMultiDetailsExpansion: _propTypes2.default.bool,
  hideHeader: _propTypes2.default.bool
};

DataTable.displayName = 'DataTable';

exports.default = DataTable;